<template>
    <v-container class="h-100">
        <v-card class="card-container">
            <v-card-title>
                <v-row>
                    <v-col cols="auto">
                        <v-btn
                                dense
                                color="var(--color-blue)"
                                @click="showAddModal"
                                dark
                        >
                            <span class="btn-text"><v-icon dark>add</v-icon> Подать заявку на акцию</span>
                        </v-btn>
                    </v-col>
                    <v-col>
                        <v-text-field
                                class="search-block"
                                v-model="search"
                                prepend-inner-icon="mdi-magnify"
                                single-line
                                solo
                                placeholder="Поиск"
                                dense
                                hide-details
                        />
                    </v-col>
                    <v-spacer></v-spacer>
                </v-row>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text class="h-100 pt-0" style="overflow-y: scroll">
                <v-container class="stocks-tables-container">
                    <div class="table-header">Акции на одобрении: {{activeCount}}</div>
                    <v-row v-if="activeCount==0" no-gutters class="no-active">
                        <v-col align-self="center">
                            <div class="no-active_text">Создайте акцию для проверки и одобрения</div>
                        </v-col>
                    </v-row>
                    <v-row v-else no-gutters>
                        <v-col>
                            <v-data-table
                                    :loading="loading"
                                    no-data-text="Нет элементов"
                                    no-results-text="Не найдено элементов"
                                    loading-text="Загрузка данных"
                                    calculate-widths
                                    :items-per-page="activeItems.length"
                                    :items="activeItems"
                                    :headers="fieldsActive"
                                    :search="search"
                                    height="100%"
                                    hide-default-footer
                                    class="elevation-1 h-100"
                                    @click:row="showDetailModal"
                            >
                                <template v-slot:item.stockSize="{item}">
                                    <div> {{ sizesStock.find(x=>x.value==item.stockSize).text }}</div>
                                </template>
                                <template v-slot:item.organization="{item}">
                                    <div>{{item.organization.orgName}}</div>
                                </template>
                                <template v-slot:item.sendToReviewDate="{item}">
                                    <div v-if="item.stockStatusCode=='SS02'">{{formatDate(item.sendToReviewDate)}}</div>
                                </template>
                                <template v-slot:item.stockStatus="{item}">
                                    <div :class="{'rejected':item.stockStatusCode=='SS03'}">{{item.stockStatus}}</div>
                                </template>
                                <template v-slot:item.stockDescription="{item}">
                                    <span style="color:var(--color-2)">{{ item.stockDescription.length>150?item.stockDescription.substr(0,150)+'...':item.stockDescription }}</span>
                                </template>

                            </v-data-table>
                        </v-col>
                    </v-row>
                    <div class="table-header">Действующие акции: {{approvedCount}}</div>
                    <v-row style="height: 100%" no-gutters>
                        <v-col>
                            <v-data-table
                                    :loading="loading"
                                    no-data-text="Нет элементов"
                                    no-results-text="Не найдено элементов"
                                    loading-text="Загрузка данных"
                                    calculate-widths
                                    :items-per-page="publishedItems.length"
                                    :items="publishedItems"
                                    :headers="fieldsApproved"
                                    :search="search"
                                    height="100%"
                                    hide-default-footer
                                    class="elevation-1 h-100"
                                    @click:row="showDetailModal"
                            >
                                <template v-slot:item.stockSize="{item}">
                                    <div> {{ sizesStock.find(x=>x.value==item.stockSize).text }}</div>
                                </template>
                                <template v-slot:item.organization="{item}">
                                    <div>{{item.organization.orgName}}</div>
                                </template>
                                <template v-slot:item.publishDate="{item}">
                                    <div>{{formatDate(item.publishDate)}}</div>
                                </template>
                                <template v-slot:item.stockDescription="{item}">
                                    <span style="color:var(--color-2)">{{ item.stockDescription.length>150?item.stockDescription.substr(0,150)+'...':item.stockDescription }}</span>
                                </template>

                            </v-data-table>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
        </v-card>

        <addModal :show="showAdd" @close="closeAddModal"></addModal>
        <detailsModal :show="showDetails" :item="selected" @close="closeDetailsModal"></detailsModal>
        <editModal :show="showEdit" :item="selected" @close="closeDetailsModal"></editModal>

    </v-container>
</template>

<script>

    import addModal from '../components/Stocks/AddStockModal.vue'
    import detailsModal from '../components/Stocks/DetailsStockModal.vue'
    import editModal from '../components/Stocks/EditStockModal.vue'
    export default {
        name: "Stocks",
        components:{addModal,detailsModal,editModal},
        data() {
            return {
                errors: [],
                loading:false,
                imageModel: null,
                imageDetailModel: null,
                videoModel: null,
                editModel: {
                    id: null,
                    organizationId: null,
                    organization: null,
                    stockImage: null,
                    stockDetailImage: null,
                    stockVideo: null,
                    stockTitle: null,
                    stockDescription: null,
                    stockSize: null,
                    isActive: true
                },
                search: "",
                fieldsApproved: [
                    {text: 'Название', value: 'stockTitle',width: "250px"},
                    {text: 'Партнер', value: 'organization',width: "200px"},
                    {text: 'Размер плитки', value: 'stockSize',width: "150px"},
                    {text: 'Дата публикации', value: 'publishDate',width: "150px"},
                    {text: 'Текст акции', value: 'stockDescription'}
                ],
                fieldsActive: [
                    {text: 'Название', value: 'stockTitle',width: "200px"},
                    {text: 'Партнер', value: 'organization',width: "200px"},
                    {text: 'Размер плитки', value: 'stockSize',width: "150px"},
                    {text: 'Дата отправки', value: 'sendToReviewDate',width: "150px"},
                    {text: 'Текст акции', value: 'stockDescription'},
                    {text: 'Статус', value: 'stockStatus'},
                ],
                selected: null,
                showAdd:false,
                showEdit:false,
                showDetails:false,

            }
        },
        beforeMount() {
            this.loadData()
            this.$store.dispatch("Stocks/getOrgItems").catch(err=>{
                this.$bvToast.toast(err.message, {
                    title: `Ошибка загрузки списка партнеров!`,
                    variant: "danger",
                    toaster: 'b-toaster-bottom-right',
                    autoHideDelay: 3000,
                    solid: true
                })
            })
        },
        computed: {
            isAdmin(){
                let user= this.$store.state.userData.webUser
                if(user!=null){
                    return user.isAdmin
                }
                else return false
            },

            activeCount() {
                return this.activeItems.length
            },

            activeItems() {
                return this.$store.state.Stocks.activeItems;
            },

            approvedCount() {
                return this.publishedItems.length
            },

            publishedItems() {
                return this.$store.state.Stocks.publishedItems;
            },

            sizesStock(){
                return this.$store.state.Stocks.sizesStock;
            }

        },
        methods: {

            loadData(){
                //заполняем данные справочника
                this.$store.dispatch("Stocks/loadPublishedStocks").catch((err) => {
                    this.$bvToast.toast(err.message, {
                        title: `Ошибка загрузки акций!`,
                        variant: "danger",
                        toaster: 'b-toaster-bottom-right',
                        autoHideDelay: 3000,
                        solid: true
                    })
                });
                //заполняем данные справочника
                this.$store.dispatch("Stocks/loadActiveStocks").catch((err) => {
                    this.$bvToast.toast(err.message, {
                        title: `Ошибка загрузки акций!`,
                        variant: "danger",
                        toaster: 'b-toaster-bottom-right',
                        autoHideDelay: 3000,
                        solid: true
                    })
                });

            },

            showDetailModal(e){
                this.selected = e;
                if(this.isAdmin==true){
                    //статус акции черновик
                    if(this.selected.stockStatusCode=='SS01')
                        this.showEdit=true
                    else
                        this.showDetails=true
                }
                else
                    //пользователям партнера открываем окно редактирования
                    this.showEdit=true
            },

            closeDetailsModal(isSave){
                this.showDetails=false
                this.showEdit=false
                if(isSave==true){
                    this.loadData();
                }
            },

            showAddModal() {
                this.showAdd=true
            },

            closeAddModal(isSave){
                this.showAdd=false
                if(isSave==true){
                    this.loadData();
                }
            },
        }
    }
</script>

<style scoped>
    .stocks-tables-container {
        display: flex;
        flex-direction: column;
        height: 100%;
        padding-top: 0;
    }

    .no-active {
        height: 80px;
        max-height: 80px;
        background: #F5F7FD;
    }

    .no-active_text {
        font-weight: 500;
        font-size: 16px;
        line-height: 20px;
        color: #6E7C8D;
        margin: 20px;
        vertical-align: middle;
    }

    .table-header {
        font-weight: 600;
        font-size: 18px;
        line-height: 20px;
        color: black;
        margin-top: 30px;
        margin-bottom: 20px;
    }

    .rejected{
        color:var(--color-red);
        font-weight: 600;
    }
</style>
